import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSitesRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Builder/GetBuilderSites`,
	params: {}
});

export const GetSiteDetailsRequest = (siteId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Builder/GetBuilderSiteDetails`,
	params: { siteId }
});

export const EditValueRequest = (cellRowData, tech) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Builder/SaveBuilderCellDetails`,
	data: { cellRowData, tech }
});

export const RunAlgoPlanRequest = (siteId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Planning/Algorithm`,
	params: { siteId }
});

export const CreateScriptsRequest = (cells, operation, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}Builder/BuildAndProcessJson`,
	data: { cells, operation, userId }
});
